import { render, staticRenderFns } from "./FilterItemTag.vue?vue&type=template&id=37fb52ba&scoped=true&"
import script from "./FilterItemTag.vue?vue&type=script&lang=js&"
export * from "./FilterItemTag.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemTag.vue?vue&type=style&index=0&id=37fb52ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb52ba",
  null
  
)

export default component.exports